import { Component, OnDestroy, OnInit } from '@angular/core';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { Subscription, interval } from 'rxjs';
import { SharedService } from '../../shared.service';
import { AuthService } from 'src/app/services/auth.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'pq-expiring-session-countdown',
  standalone: false,
  templateUrl: './expiring-session-countdown.component.html',
  styleUrl: './expiring-session-countdown.component.css',
})
export class ExpiringSessionCountdownComponent implements OnInit, OnDestroy {
  targetTime: number = environment.userInactivityResponseSeconds;
  remainingTime: number = this.targetTime;
  displayTime: string = this.formatTime(this.remainingTime);
  countdownSubscription: Subscription | undefined;

  constructor(
    private sharedSerivce: SharedService,
    private readonly authService: AuthService,
    private dialogRef: DynamicDialogRef
  ) {}

  ngOnInit(): void {
    this.startCountDown();
  }
  ngOnDestroy(): void {
    this.stopCountdown();
  }

  startCountDown() {
    this.countdownSubscription = interval(1000).subscribe(() => {
      if (this.remainingTime > 0) {
        this.remainingTime--;
        this.displayTime = this.formatTime(this.remainingTime);
      } else {
        this.stopCountdown();
        this.sharedSerivce.showNotification(
          false,
          'Logged Out',
          'You have been logged out due to inactivity'
        );
        this.logout();
      }
    });
  }

  private stopCountdown() {
    if (this.countdownSubscription) {
      this.countdownSubscription.unsubscribe();
    }
  }

  private formatTime(seconds: number): string {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${this.pad(minutes)}:${this.pad(remainingSeconds)}`;
  }

  private pad(value: number): string {
    return value < 10 ? `0${value}` : value.toString();
  }

  logout() {
    this.dialogRef.close();
    this.authService.logout();
  }

  resumeSession() {
    this.dialogRef.close();
    this.authService.refreshToken();
  }
}
